var _g, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLostVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608 383",
    role: "img",
    filter: "url(#grayscale)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "lost video") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M436.775 118.328l3.375-7.504c.254.114.528.197.832.229 1.141.12 2.339-.809 2.559-1.94.472-.215.817-.693 1.033-1.164l4.699 3.094s-3.569 8.348-7.281 10.808c-3.712 2.461-15.529 9.041-15.529 9.041l-1.881-1.077 12.193-11.487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M423.943 130.071c-.14.154-.672.639-2.096.992-1.277.317-4.126.198-3.393 1.392 1.347.47 2.875 1.182 2.875 1.182.843.204 2.187-.367 2.958-.88l2.176-1.865s-.011-1.392 0-1.457l-.59-.136a6.75 6.75 0 0 1-1.93.772"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M423.592 130.712s-.033.07-.119.178c.184.042.362.093.537.149.682-.09 1.365-.161 2.047-.245a31.782 31.782 0 0 1-.255-.964l-4.574-.337s-.281.521.604.891c.886.369 1.76.328 1.76.328M1.927 146.687a2.69 2.69 0 0 0-.597 1.821l-.291 2.488.34.385 1.167 1.036c-.041-.515-.099 0-.099 0l1.877-3.267s2.269-1.455-.593-3.602c-.274-.205-.657-.25-.941-.06a2.108 2.108 0 0 0-.863 1.199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0306E",
    d: "M112.41 367.28H4.603c-2.366 0-4.303-1.663-4.303-3.697v-92.607c0-2.032 1.937-3.695 4.303-3.695H112.41c2.367 0 4.304 1.663 4.304 3.695v92.607c0 2.034-1.937 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M229.816 266.28H122.01c-2.368 0-4.304-1.663-4.304-3.697v-92.606c0-2.033 1.936-3.697 4.304-3.697h107.806c2.367 0 4.304 1.664 4.304 3.697v92.606c0 2.034-1.937 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M86.79 367.461c-3.442-29.839-11.176-49.653-29.221-49.653-17.499 0-25.415 19.814-29.04 49.653H86.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M43.521 303.174c0 9.689 6.44 17.544 14.385 17.544 7.945 0 14.386-7.855 14.386-17.544 0-9.691-6.441-17.545-14.386-17.545-7.945 0-14.385 7.854-14.385 17.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M70.923 309.299c5.094-10.209 2.969-20.448.765-22.991-3.41-3.935-8.058-5.991-13.468-5.991-5.411 0-10.427 2.123-12.937 5.812-.837 1.23-6.289 8.381-.83 23.218-.388-7.484.6-18.372 3.541-15.996 14.044 11.349 19.415 9.269 21.311 10.762 2.554 2.011.437 5.703 1.618 5.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M58.493 322.339l6.627-4.226 2.3.453-4.662 10.29-4.265-6.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M58.852 322.339l-7.867-3.784-2.283 1.278 5.659 9.024 4.491-6.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M70.475 320.131c5.055 3.76 13.294 9.827 14.959 16.427 4.759 18.881-15.062 17.457-15.062 17.457s10.218-4.064.785-23.55c-.371-.765-12.723-19.291-.682-10.334"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M112.121 165H4.315c-2.367 0-4.304-1.664-4.304-3.697V68.696C.011 66.664 1.948 65 4.315 65h107.806c2.368 0 4.304 1.664 4.304 3.696v92.607c0 2.033-1.936 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M67.125 99.718c2.427 4.608-.636 10.034-2.429 14.924-3.019 8.236-2.893 21.058 2.229 28.834 1.841 2.795 3.93 4.844 6.057 6.341 7.121 5.012 17.053.736 18.489-7.853 1.942-11.608-9.106-16.931-15.688-49.302-5.873-14.715-10.196-10.16-12.653-9.586-5.74 1.34.836 10.644 3.995 16.642m-18.689 0c-2.427 4.608.637 10.034 2.429 14.924 3.019 8.236 2.894 21.058-2.228 28.834-1.841 2.795-3.931 4.844-6.058 6.341-7.121 5.012-17.053.736-18.489-7.853-1.941-11.608 9.106-16.931 15.689-49.302 5.873-14.715 10.195-10.16 12.652-9.586 5.74 1.34-.836 10.644-3.995 16.642"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M86.156 164.907c-3.442-29.839-11.176-49.652-29.222-49.652-17.498 0-25.415 19.813-29.04 49.652h58.262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M42.887 100.62c0 9.689 6.441 17.544 14.385 17.544 7.945 0 14.386-7.855 14.386-17.544 0-9.69-6.441-17.544-14.386-17.544-7.944 0-14.385 7.854-14.385 17.544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M71.137 106.745c5.094-10.209 2.12-20.447-.083-22.99-3.411-3.935-8.058-5.991-13.469-5.991-5.41 0-10.426 2.123-12.936 5.812-.837 1.23-7.136 9.227-1.677 24.065-.389-7.484 1.447-17.524 4.387-15.149 14.045 11.349 24.499 6.727 26.395 8.22 2.555 2.011-3.799 6.551-2.617 6.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M57.859 119.785l6.626-4.225 2.301 2.147-4.662 8.596-4.265-6.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M58.218 119.785l-7.867-3.784-2.284 1.279 5.659 9.024 4.492-6.519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M229.817 367.28H122.011c-2.368 0-4.304-1.663-4.304-3.697v-92.607c0-2.032 1.936-3.695 4.304-3.695h107.806c2.367 0 4.304 1.663 4.304 3.695v92.607c0 2.034-1.937 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M206.919 367.356c-3.717-29.965-11.848-49.718-30.259-49.718-17.853 0-26.153 19.753-30.057 49.718h60.316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M161.988 302.353c0 10.12 6.726 18.324 15.024 18.324 8.298 0 15.025-8.204 15.025-18.324 0-10.119-6.727-18.323-15.025-18.323s-15.024 8.204-15.024 18.323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M191.53 308.179c2.358-9.495 2.674-11.925 2.674-11.925s-.497-7.115-.952-8.145c-.458-1.029-9.737-7.792-15.684-7.792-5.946 0-13.78 5.644-14.803 6.974-1.024 1.33-1.731 6.43-1.731 6.43s-.812 5.782 1.975 14.458c-.427-8.585-.802-16.121 3.027-14.443 17.92 7.855 20.598-2.146 22.834.702 5.196 6.619 1.363 14.334 2.66 13.741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M170.79 367.356h13.558l-5.145-31.312 4.411-9.353-5.015-4.401h-2.588l-4.884 4.792 4.927 8.832-5.264 31.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M112.41 266.28H4.603c-2.366 0-4.303-1.663-4.303-3.697v-92.606c0-2.033 1.937-3.697 4.303-3.697H112.41c2.367 0 4.304 1.664 4.304 3.697v92.606c0 2.034-1.937 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M93.115 266.463c-3.718-29.965-11.849-49.718-30.26-49.718-17.853 0-26.153 19.753-30.057 49.718h60.317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M48.184 201.46c0 10.12 6.726 18.324 15.024 18.324 8.298 0 15.024-8.204 15.024-18.324 0-10.12-6.726-18.323-15.024-18.323-8.298 0-15.024 8.203-15.024 18.323"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M77.725 207.285c2.359-9.494 2.675-11.924 2.675-11.924s-.497-7.116-.952-8.145c-.458-1.03-9.737-7.792-15.685-7.792-5.945 0-13.779 5.643-14.803 6.973-1.024 1.331-1.731 6.429-1.731 6.429s-.812 5.783 1.975 14.459c-.427-8.585-.801-16.12 3.028-14.442 17.92 7.854 20.597-2.147 22.833.702 5.196 6.619 1.364 14.334 2.66 13.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M56.986 266.463h13.557l-5.145-31.313 4.411-9.352-5.014-4.402h-2.588l-4.885 4.792 4.927 8.832-5.263 31.443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M347.225 367.28H239.418c-2.366 0-4.302-1.663-4.302-3.697v-92.607c0-2.032 1.936-3.695 4.302-3.695h107.807c2.367 0 4.304 1.663 4.304 3.695v92.607c0 2.034-1.937 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M325.229 367.336c-4.069-29.182-12.602-48.182-31.023-48.182-17.864 0-26.539 19-30.791 48.182h61.814"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M278.938 303.249c0 10.53 7 19.067 15.635 19.067 8.634 0 15.633-8.537 15.633-19.067 0-10.531-6.999-19.069-15.633-19.069-8.635 0-15.635 8.538-15.635 19.069"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M309.679 309.31c2.455-9.88 2.783-12.409 2.783-12.409s.03-16.587-17.312-16.584c-16.407.003-17.205 13.947-17.205 13.947s-.845 6.018 2.055 15.046c-.444-8.934 1.166-18.9 3.151-15.029 4.595 8.968 21.433-2.234 23.761.732 5.406 6.886 1.418 14.915 2.767 14.297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M288.501 367.336h13.313l-4.894-29.03 4.522-9.731-5.218-4.58h-2.693l-5.083 4.985 5.058 9.192-5.005 29.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M209.484 266.453c-4.069-29.182-12.602-48.182-31.024-48.182-17.863 0-26.537 19-30.789 48.182h61.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M163.193 202.365c0 10.531 7 19.067 15.635 19.067 8.634 0 15.634-8.536 15.634-19.067s-7-19.067-15.634-19.067c-8.635 0-15.635 8.536-15.635 19.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M194.782 205.037c2.454-9.879 1.936-9.019 1.936-9.019s.028-16.587-17.313-16.584c-16.407.003-17.205 13.947-17.205 13.947s-1.692 2.629 1.208 11.656c-.444-8.934.144-9.62 3.998-11.639 11.996-6.286 21.434-2.234 23.76.731 5.408 6.887 2.266 11.527 3.616 10.908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF4B71",
    d: "M172.756 266.453h13.314l-4.894-29.029 4.521-9.732-5.218-4.581h-2.693l-5.083 4.986 5.058 9.191-5.005 29.165"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M347.222 266.28H239.415c-2.367 0-4.303-1.663-4.303-3.696v-92.607c0-2.033 1.936-3.697 4.303-3.697h107.807c2.367 0 4.304 1.664 4.304 3.697v92.607c0 2.033-1.937 3.697-4.304 3.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0306E",
    d: "M320.732 265.803c-3.443-29.839-11.176-49.652-29.222-49.652-17.498 0-25.415 19.813-29.039 49.652h58.261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M277.462 201.515c0 9.69 6.442 17.545 14.386 17.545 7.945 0 14.386-7.855 14.386-17.545 0-9.689-6.441-17.544-14.386-17.544-7.944 0-14.386 7.855-14.386 17.544"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M304.866 207.641c5.093-10.209 2.967-20.448.764-22.99-3.411-3.935-8.058-5.991-13.468-5.991-5.412 0-10.427 2.123-12.937 5.812-.837 1.229-6.289 8.379-.83 23.218-.388-7.485.6-18.372 3.54-15.997 14.045 11.349 19.415 9.269 21.311 10.762 2.555 2.011.438 5.704 1.62 5.186"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M292.435 220.681l6.626-4.226 2.301.454-4.661 10.29-4.266-6.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M292.794 220.681l-7.867-3.784-2.284 1.279 5.659 9.024 4.492-6.519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M278.395 207.69s-1.005 18.125-10.324 24.479c5.083 10.644 14.572 9.076 14.572 9.076s8.816-15.141 2.284-24.348l-6.532-9.207m26.301 0s1.005 18.125 10.324 24.479c-5.083 10.644-14.573 9.076-14.573 9.076s-8.816-15.141-2.284-24.348l6.533-9.207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M229.816 165H122.01c-2.368 0-4.304-1.664-4.304-3.696V68.697c0-2.033 1.936-3.697 4.304-3.697h107.806c2.367 0 4.304 1.664 4.304 3.697v92.607c0 2.032-1.937 3.696-4.304 3.696"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M205.891 164.225c-3.442-29.839-11.176-49.652-29.222-49.652-17.498 0-25.415 19.813-29.04 49.652h58.262"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M162.621 99.938c0 9.689 6.441 17.544 14.386 17.544 7.945 0 14.386-7.855 14.386-17.544 0-9.69-6.441-17.545-14.386-17.545-7.945 0-14.386 7.855-14.386 17.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M190.024 106.063c5.095-10.209 2.968-20.447.764-22.99-3.41-3.935-8.057-5.991-13.467-5.991-5.411 0-10.428 2.122-12.937 5.811-.837 1.23-6.289 8.381-.83 23.219-.389-7.484-.208-15.507 3.54-15.996 14.963-1.955 20.676-.012 22.571 1.481 2.555 2.011-.822 14.983.359 14.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M177.594 119.103l6.626-4.225 2.301 2.147-4.662 8.596-4.265-6.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M177.953 119.103l-7.867-3.784-2.284 1.279 5.659 9.023 4.492-6.518"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M168.649 75.322c0 3.905 4.09 7.071 9.134 7.071 5.045 0 9.133-3.166 9.133-7.071s-4.088-7.071-9.133-7.071c-5.044 0-9.134 3.166-9.134 7.071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7676",
    d: "M418.112 142.864l-94.29-52.266c-2.07-1.147-2.958-3.542-1.972-5.32l44.896-80.995c.986-1.778 3.487-2.294 5.557-1.147l94.29 52.266c2.07 1.148 2.957 3.542 1.971 5.32l-44.896 80.995c-.986 1.778-3.486 2.295-5.556 1.147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M397.063 131.123c11.275-28.01 13.741-49.228-2.362-58.154-15.615-8.656-32.451 4.598-50.392 28.912l52.754 29.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M389.28 52.487c-4.907 8.852-3.002 19.288 4.256 23.31 7.258 4.024 17.117.11 22.024-8.742 4.906-8.85 3-19.287-4.257-23.31-7.258-4.023-17.118-.108-22.024 8.742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M415.498 67.87c6.667-7.16 7.38-9.545 7.38-9.545s.55-2.017.65-3.14c.1-1.12-4.737-11.534-9.94-14.418-5.2-2.882-14.787-1.744-16.328-1.077-1.54.668-4.63 4.784-4.63 4.784s-2.201.548-3.97 9.487c3.789-7.716 5.8-10.371 8.337-7.048 11.866 15.557 19.057 8.109 19.63 11.685 1.336 8.308-2.55 9.161-1.129 9.271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M365.463 113.607l11.859 6.574 12.243-30.953 6.828-4.97-2.25-6.28-2.264-1.255-6.596 1.823.108 8.22-19.928 26.841"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M395.115 42.305a4.937 4.937 0 1 1 9.39-3.059 4.937 4.937 0 0 1-9.39 3.059m20.745 13.643a4.938 4.938 0 1 1 9.389-3.056 4.938 4.938 0 0 1-9.389 3.056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M389.168 48.66a8.37 8.37 0 1 1 15.919-5.184 8.37 8.37 0 0 1-15.92 5.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M397.946 48.89a8.368 8.368 0 0 1 5.366-10.55 8.37 8.37 0 1 1-5.366 10.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M413.934 52.736a4.937 4.937 0 1 1 9.389-3.058 4.937 4.937 0 0 1-9.39 3.058"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M401.447 44.274a7.16 7.16 0 1 1 13.616-4.436 7.16 7.16 0 0 1-13.616 4.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M406.024 48.79a7.162 7.162 0 1 1 13.62-4.436 7.162 7.162 0 0 1-13.62 4.435m-216.801 161.05c-.376-.604-1.475-.806-1.475-.806s1.373 1.031.383 2.121c0 0-.693.532-2.093-.49-1.422-1.035-3.126-1.828-4.778-1.857-1.589-.028-1.649.435-1.836.785-.185-.35-.246-.813-1.836-.785-1.651.029-3.355.822-4.778 1.857-1.4 1.022-2.092.49-2.092.49-.989-1.09.382-2.121.382-2.121s-1.098.202-1.474.806c-.526.846-.924 1.986.973 3.155 1.812 1.118 3.775.62 6.753 0 1.178-.244 1.783-.766 2.072-1.329.29.563.894 1.085 2.072 1.329 2.979.62 4.941 1.118 6.754 0 1.897-1.169 1.499-2.309.973-3.155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M242.125 31.454l-4.394 1.321-1.117-4.767 7.134-.377-1.623 3.823"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M242.743 32.555c.254.509.554.951.874 1.105 2.852.48 7.888-3.926 7.888-3.926l-.106-2.84-3.287-2.141-3.984 1.647c-1.063.439-1.83 1.405-2.064 2.601a6.812 6.812 0 0 0 .679 3.554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M246.121 26.259c.733-.139 2.206-.931 2.407-.212.147.524.856 2.225 1.118 2.786.623 1.339 2.258 3.48 4.295 2.532 1.017-.474 1.435-1.871 1.405-2.619-.029-.733-.365-1.42-.877-1.946-1.201-1.234-3.249-2.659-3.455-3.511-.348-1.434-1.726-2.384-2.831-1.847-1.182.574-2.682 2.029-3.547 3.144-.5.645-.88 1.373-1.126 2.151l2.611-.478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M245.342 24.97c.402.176.612.758.469 1.3-.143.541-.585.838-.987.662-.403-.175-.613-.756-.47-1.298.143-.542.585-.839.988-.664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M228.698 34.88s2.057 9.433 4.613 13.718c2.555 4.288 12.772 11.3 12.772 11.3l.805-2.941-7.806-9.835-1.403-11.225-8.98-1.017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M246.892 57.105c.09.247.478 1.068 1.968 2.164 1.336.985 4.716 2.216 3.288 3.256-1.798-.1-3.92-.006-3.92-.006-1.083-.167-2.376-1.478-3.027-2.448l-1.643-3.222s.684-1.617.702-1.7l.753.126a8.517 8.517 0 0 0 1.88 1.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M246.994 58.021s.005.097.052.265a7.594 7.594 0 0 0-.698-.085c-.75-.434-1.514-.844-2.269-1.27.308-.397.738-.957.76-1.002l5.498 1.808s.078.743-1.134.747c-1.21.004-2.21-.463-2.21-.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M237.475 33.258l.772 6.495-6.386 3.241 2.419-10.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M226.211 61.395s1.844 1.71 6.047 2.78c.925.236 1.923-.079 1.923 1.447h-5.101l-4.242-.733v.733h-2.291s-.638-3.746.7-4.227h2.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M225.761 58.703l.45 2.692a2.591 2.591 0 0 1-2.807.094l-.157-.094.228-2.692h2.286m-39.171.068l-2.474-.489a2.42 2.42 0 0 1 .212-2.615l.104-.136 2.497.287-.339 2.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M215.952 46.038s3.188-.129 9.489-4.021c-4.262 7.59-2.872 17.925-2.872 17.925h3.614l8.896-23.304-21.314-1.108v10.75l2.187-.242"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE3D6F",
    d: "M239.157 27.666s-11.121-11.518-33.176 3.063l9.452 11.288 11.491-3.892 8.711 2.409 3.522-12.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M226.924 38.125s.556 9.638 2.41 14.271c1.853 4.634 10.847 13.159 10.847 13.159l1.255-2.78-6.171-10.935.37-11.306-8.711-2.409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M241.417 62.922c.05.258.305 1.13 1.605 2.446 1.166 1.181 4.311 2.926 2.738 3.73-1.76-.381-3.871-.619-3.871-.619-1.043-.335-2.115-1.832-2.606-2.892l-1.119-3.439s.928-1.49.959-1.569l.724.242a8.525 8.525 0 0 0 1.57 2.101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M241.374 63.843s-.01.097.01.27a7.594 7.594 0 0 0-.676-.193c-.673-.546-1.363-1.071-2.042-1.61.366-.344.878-.829.908-.87l5.147 2.645s-.04.746-1.237.561a5.753 5.753 0 0 1-2.11-.803"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M205.981 30.729s-5.931 4.558-6.302 10.362c-.37 5.802 5.56 16.643 5.56 16.643s-6.639-5.555-18.702-2.372c-.759 3.182-.759 3.839-.759 3.839s25.022 9.112 28.728 4.598c3.707-4.513.927-21.782.927-21.782l-9.452-11.288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M184.409 58.282s-1.868.579-2.295 6.165c-.088 1.146-.482.865-.89 1.165-.375-1.722-1.313-5.295-1.313-5.295l1.402-3.682-.792-.598 1.304-2.068s2.596.269 2.9 1.562l-.316 2.751"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M444.63 99.904l1.534 3.4 4.496-2.101-3.881-5.586-2.149 4.287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M439.187 91.261s.989 8.806 2.994 9.657c2.005.851 4.37-2.129 4.37-2.129l2.251-5.217-7.144-3.077-2.471.766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M435.937 89.514s1.527 3.055 5.939 1.687c1.246.026 1.915 1.278 2.266 2.39.406 1.288.543.301 1.569 1.18l1.796 2.575s4.124-7.751-1.437-10.089c-5.562-2.339-10.133 2.257-10.133 2.257"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M445.389 93.43c-.423-.113-.947.21-1.172.722-.224.512-.063 1.018.36 1.13.422.112.947-.211 1.171-.723.225-.511.064-1.017-.359-1.129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF4B71",
    d: "M452.462 100.833c11.094 6.575 6.867 33.731 6.867 33.731h-16.872s-.194-7.102-.417-14.604c-.168-5.681-.705-11.592.818-14.822 2.125-4.452 6.849-5.937 9.604-4.305"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M446.67 118.432s-2.514 8.724-5.896 11.623c-3.381 2.898-13.103 10.713-13.103 10.713l-3.193-.669 10.686-12.898 3.87-12.542 7.636 3.773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF4B71",
    d: "M447.49 119.252l-9.277-3.773 4.645-10.341 6.12 3.186-1.488 10.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M463.041 193.665s-1.866 1.73-6.121 2.814c-.936.239-1.946-.08-1.946 1.465h5.163l4.294-.742v.742h2.319s.647-3.793-.709-4.279h-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M463.497 190.94l-.456 2.725a2.624 2.624 0 0 0 2.841.095l.159-.095-.23-2.725h-2.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M459.329 134.564s1.657 5.678 1.991 19.546c.068 2.805.83 5.536 2.051 8.063 4.848 10.038 2.654 29.451 2.654 29.451h-3.348l-13.391-47.698 4.712-9.362h5.331m-14.505 60.741s-1.866 1.73-6.12 2.814c-.937.239-1.947-.08-1.947 1.465h5.163l4.294-.742v.742h2.32s.645-3.793-.709-4.279h-3.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M445.281 192.58l-.457 2.725a2.623 2.623 0 0 0 2.841.095l.16-.095-.231-2.725h-2.313m-17.61-51.812l-2.535 3.742c-1.142 1.439-4.084.851-5.922-.078a.413.413 0 0 1-.049-.704c1.322-.944 4.741-3.355 5.847-3.821l2.659.861"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M442.457 134.564l1.659 58.837h3.529s4.969-16.363 3.883-27.653c-.295-3.069.118-6.169 1.34-9.001 5.24-12.146 4.411-22.183 4.411-22.183h-14.822"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M437.394 157.768h-5.949l-.163 45.893h6.322l-.21-45.893m40.492 0h-5.949l-.163 45.893h6.322l-.21-45.893"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M428.116 158.81l52.447.017-.01-2.642-52.437.146v2.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M453.094 156.283l-.015 46.049 2.521-.008-.139-46.041h-2.367m90.331 2.544h5.984v-5.983h-5.984zm56.426 195.114H493.628c-4.061 0-7.385-3.324-7.385-7.386 0-4.063 3.324-7.387 7.385-7.387h106.223c4.063 0 7.387 3.324 7.387 7.387 0 4.062-3.324 7.386-7.387 7.386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M521.363 357.907c0 8.285-6.715 15-15 15s-15-6.715-15-15c0-8.284 6.715-15 15-15s15 6.716 15 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M517.363 357.907c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M603.363 357.907c0 8.285-6.716 15-15 15-8.284 0-15-6.715-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M599.363 357.907c0 6.075-4.924 11-11 11-6.075 0-11-4.925-11-11s4.925-11 11-11c6.076 0 11 4.925 11 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M566.341 341.399h-37.663c-8.276 0-15.048-.447-15.048-4.003v-8.116c0-6.814 12.98-12.881 28.843-12.881h10.074c15.863 0 28.842 6.067 28.842 12.88v8.117c0 3.556-6.771 4.003-15.048 4.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M536.02 319.622h21.166v-5.389H536.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M535.422 240.073l.598 74.16h7.906l-.032-74.16h-8.472m18.203 0l.267 74.16h3.294l-.031-74.16h-3.53m41.047-42.735l-38.084 42.735h-7.906l37.518-42.735h8.472m-18.203 0l-37.753 42.735h-3.294l37.518-42.735h3.529m-41.047-42.735l38.083 42.735h7.907l-37.518-42.735h-8.472m18.203 0l37.752 42.735h3.295l-37.517-42.735h-3.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M556.923 154.603l-58.426 42.735h-7.906l57.861-42.735h8.471m-18.203 0l-58.095 42.735h-3.294l57.861-42.735h3.528m-3.298 85.47h21.955l-11.02-12.545-10.935 12.545m37.518-42.735h21.732l-10.283-11.713-11.449 11.713m-37.518-42.735h21.501l-10.45-11.645-11.051 11.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M431.282 197.548v5.949l66.828.164v-6.323l-66.828.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M484.423 343.37c2.488 17.79-.235 36.222-.235 36.061 0-.16-1.982 0-1.982 0s-2.75-21.625-3.394-28.842c-.645-7.219 0-7.701 0-7.701s3.124-17.308 5.611.482"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M485.078 297.464l6.083 3.879 2.566-5.348-7.86-9.008-.789 10.477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M452.97 261.84l7.448 19.461 4.756-3.539-10.627-17.915-1.577 1.993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M452.539 255.233a3.073 3.073 0 0 1 1.095 1.897l.913 2.717-.289.511-1.288 1.482c-.075-.586-.508-1.017-.508-1.017l-2.026-2.268s-3.324-3.875-.222-5.191c-1.82-3.601-.517-3.508-.517-3.508l2.842 5.377"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M452.072 255.943s.671-.632.074-2.134c-.598-1.503.306-1.397.306-1.397s2.487 5.855 1.688 6.522c-.799.666-2.068-2.991-2.068-2.991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF5973",
    d: "M474.318 285.302l-2.231.173-7.577-8.833-4.092 4.659s3.753 7.089 9.248 14.427c.313 1.492 1.94 16.507 1.94 16.507h13.139s-2.093-11.017 1.603-17.148c3.696-6.132-12.03-9.785-12.03-9.785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M478.623 343.37c2.489 17.79-.234 36.222-.234 36.061 0-.16-1.983 0-1.983 0s-2.748-21.625-3.394-28.842c-.644-7.219 0-7.701 0-7.701s3.124-17.308 5.611.482m-4.784-71.809l7.569 2.65-.746 5.649c-.011.08-.033.157-.047.236a7.313 7.313 0 0 0-.436.088l-.07.021c-.023.005-.045.008-.069.014-1.746.429-2.982 1.872-3.538 3.542a8.975 8.975 0 0 1-3.275-.042c-.741-.153-1.411-.386-1.721-.743-1.596-3.484 2.333-11.415 2.333-11.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M473.644 276.318c.684 1.364.807 2.971.155 4.35-1.029 2.178-.938 4.622-.253 5.963.467.914 1.689 1.828 2.772 2.503a4.281 4.281 0 0 1 2.01 3.239c.168 1.838.343 4.093 1.917 4.636 4.567 1.573 6.242 1.421 6.851-2.386.155-.972.103-2.401-.394-3.73a6.673 6.673 0 0 1 .141-4.999c.457-1.044.863-2.192.863-2.984 0-.862-.791-2.075-1.621-3.111-1.035-1.291-1.491-2.936-1.344-4.585.146-1.648-.083-3.753-1.755-5.18-3.121-2.663-10.049 1.527-10.049 1.527s-.665 2.019.707 4.757"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0AB85",
    d: "M493.727 295.995l2.922 3.025c1.941 2.009 2.542 4.807.209 6.344l-9.547 7.583.878 1.644a4.006 4.006 0 0 1-.35 4.318l-1.009 1.322-2.234-7.667 6.922-8.642a1.66 1.66 0 0 0-.357-2.579l2.566-5.348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0306E",
    d: "M471.606 312.235s-1.925 4.992-1.925 10.049c0 2.778 2.406 23.732 2.406 23.732h12.509c-.848-15.474 3.844-17.372 3.844-24.061 0-4.718-3.695-9.72-3.695-9.72h-13.139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M484.189 377.104s1.094.86.893 1.955c-.2 1.096-.484 3.663-.484 3.663h-1.125l.035-2.394c-.004-.156-2.412 2.394-2.82 2.394h-5.95s-.396-1.615 3.098-2.134c3.495-.519 6.353-3.484 6.353-3.484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M477.834 377.104s1.093.86.893 1.955c-.2 1.096-.484 3.663-.484 3.663h-1.124l.034-2.394c-.003-.156-2.412 2.394-2.82 2.394h-5.951s-.395-1.615 3.1-2.134c3.494-.519 6.352-3.484 6.352-3.484"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "grayscale"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostVideo);
export default __webpack_public_path__ + "static/media/lost-video.4e93718cb3ed667f0ab11fee631361f6.svg";
export { ForwardRef as ReactComponent };